import React, { createContext, useContext, useState, ReactNode } from 'react';

interface UIContextValue {
  navVisible: boolean;
  setNavVisible: (visible: boolean) => void;
  showWave: boolean;
  setShowWave: (show: boolean) => void;
}

const UIContext = createContext<UIContextValue | undefined>(undefined);

export const useUI = (): UIContextValue => {
  const ctx = useContext(UIContext);
  if (!ctx) {
    throw new Error('useUI must be used within UIProvider');
  }
  return ctx;
};

export const UIProvider: React.FC<{ children: ReactNode; initialNavVisible?: boolean; initialShowWave?: boolean }> = ({ children, initialNavVisible = true, initialShowWave = true }) => {
  const [navVisible, setNavVisible] = useState<boolean>(initialNavVisible);
  const [showWave, setShowWave] = useState<boolean>(initialShowWave);
  return (
    <UIContext.Provider value={{ navVisible, setNavVisible, showWave, setShowWave }}>
      {children}
    </UIContext.Provider>
  );
};

export default UIContext;


